import StepEvent from './StepEvent';
import EventDispatcher from '@/core/event/eventDispatcher';
import AbstractView from '@/core/view/abstractView';
import LogUtil from '@/core/utils/logUtil';



class BaseStep extends AbstractView {

    protected _visible!: boolean;
    protected _animationElements!: any;
    protected _id!: string;

    get visible() {
        return this._visible;
    }

    set visible(value: boolean) {
        this._visible = value;
        if (this._element) {
            this._element.style.display = value ? '' : 'none';
        }
    }

    constructor(id: string, data: any) {
        super(id, data, null);

        this._data = data;
        this._template = '';
        this._animationElements = {};
        this._id = id;
        this._visible = false;
    }

    render(){
        super.render();

        if (this.element) {
            let next_a = this.element.querySelector('a.next_step_button');

            if(next_a) {
                next_a.addEventListener('click', () => this.finishStep(next_a));
            }
        }
    }

    finishStep(item: Element) {
        let target = (item as HTMLElement).dataset.target;

        let data = {
            next_step: target,
            id: this._id
        };

        if(target) {
            EventDispatcher.dispatchEvent(new StepEvent(StepEvent.STEP_FINISHED, data));
        }
    }

    set animationElements(map: any) {
        if (map.constructor !== Array && (map.constructor === Object || map.constructor === Map)) {
            this._animationElements = map;
        } else {
            if (LogUtil.error) LogUtil.error('Animation-elements map must be of type Map or Object.')
        }
    }

    get animationElements() {
        return this._animationElements;
    }

    getShowAnimation(): any[] {
        //return gsap.to(this._element, 0.3, {autoAlpha:1, display:''});
        return [];// return gsap.set(this._element,{autoAlpha:1, display:''});
    }

    getHideAnimation(): any[] {
        //return gsap.to(this._element, 0.3, {autoAlpha:0, display:'none'});
        return [];// gsap.set(this._element,{autoAlpha:0, display:'none'});
    }


}




export default BaseStep;
